/**
 * RatingBadge — Booking.com style decimal badge with label.
 * Renders compact ("8.4 / 10") or full ("8.4 Very Good · 124 reviews").
 */
import React from 'react';
import { ratingLabel, ratingBadgeColor, formatRating10 } from '../utils/rating10';

export const RatingBadge = ({ value, count, size = 'md', showLabel = true, testId = 'rating-badge' }) => {
  const v = Number(value) || 0;
  const color = ratingBadgeColor(v);
  const label = ratingLabel(v);
  const display = formatRating10(v);
  const px = size === 'sm' ? 'px-2 py-1 text-xs' : size === 'lg' ? 'px-3.5 py-2 text-lg' : 'px-2.5 py-1.5 text-sm';
  return (
    <div className="inline-flex items-center gap-2" data-testid={testId}>
      <span
        className={`inline-flex items-center justify-center rounded-lg font-black text-white tabular-nums ${px}`}
        style={{ backgroundColor: color, minWidth: 38 }}
        data-testid={`${testId}-score`}
      >
        {display}
      </span>
      {showLabel && (
        <span className="flex flex-col leading-tight">
          {v > 0 && <span className="text-xs font-black text-black" data-testid={`${testId}-label`}>{label}</span>}
          {typeof count === 'number' && count > 0 && (
            <span className="text-[11px] text-gray-500" data-testid={`${testId}-count`}>{count} review{count === 1 ? '' : 's'}</span>
          )}
        </span>
      )}
    </div>
  );
};

/**
 * RatingInput — 10-button selector (1..10) for submitting a rating.
 */
export const RatingInput = ({ value, onChange, testIdPrefix = 'rating-input' }) => {
  const val = Number(value) || 0;
  return (
    <div className="flex flex-wrap gap-1" data-testid={testIdPrefix}>
      {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => {
        const active = val >= n;
        return (
          <button
            key={n}
            type="button"
            onClick={() => onChange(n)}
            className={`w-9 h-9 rounded-lg border-2 font-black text-sm transition-colors tabular-nums ${
              active
                ? 'bg-[#FF0059] border-[#FF0059] text-white'
                : 'bg-white border-gray-200 text-gray-400 hover:border-[#FF0059] hover:text-[#FF0059]'
            }`}
            data-testid={`${testIdPrefix}-${n}`}
          >
            {n}
          </button>
        );
      })}
    </div>
  );
};
